import { isEmpty } from 'lodash';
import databaseReducer from './database.reducer';
import metaDatabase from './metaDatabase.reducer';
import authReducer from './auth.reducer';

export const initialState = {
    auth: {},
    database: {},
    metaDatabase: {},
};

export default function (st, action)
{
    const state = isEmpty(st) ? initialState : st;

    return {
        auth: authReducer(state.auth, action),
        database: databaseReducer(state.database, action),
        metaDatabase: metaDatabase(state.metaDatabase, action),
    };
}
